declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

export const pushUserDataToGTM = async (email: string) => {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: "userData",
    userEmail: email,
    timestamp: new Date().toISOString(),
  });
};
